export default class BadRequestError extends Error {
    constructor() {
        super();
        this.name = 'BadRequestError';
        this.message = 'SharpStar responded with "Bad Request"';
    }
}
